// Handler for opening the date selector popup
export const dateSelectorPopUpOpen = (event, setTopY, setDateSelectorPopUpAnchorEl, disabled, toggleNextButton) => {
    setTopY(event.clientY);
    if (!disabled) setDateSelectorPopUpAnchorEl(event.currentTarget);
    toggleNextButton();
};
